/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PaymentreturnImport } from './routes/payment_return'
import { Route as EmailverificationImport } from './routes/email_verification'
import { Route as ConsentformImport } from './routes/consent_form'
import { Route as Auth0callbackImport } from './routes/auth0_callback'
import { Route as MainImport } from './routes/_main'
import { Route as MainServicesCreateImport } from './routes/_main/services/create'
import { Route as MainNetworkCreateIndexImport } from './routes/_main/network/create.index'
import { Route as AdminMenuDualVirtualmachinesRouteImport } from './routes/admin/_menu/_dual/virtual_machines.route'

// Create Virtual Routes

const AdminLazyImport = createFileRoute('/admin')()
const MaincustomLazyImport = createFileRoute('/_main_custom')()
const MainIndexLazyImport = createFileRoute('/_main/')()
const AdminMenuLazyImport = createFileRoute('/admin/_menu')()
const MaincustomAboutLazyImport = createFileRoute('/_main_custom/about')()
const MainTestErrorLazyImport = createFileRoute('/_main/test-error')()
const MainProfileIndexLazyImport = createFileRoute('/_main/profile/')()
const AdminMenuSimpleLazyImport = createFileRoute('/admin/_menu/_simple')()
const MainStorageCreateLazyImport = createFileRoute('/_main/storage/create')()
const MainSectionNameLazyImport = createFileRoute('/_main/section/$name')()
const MainMetalCreateLazyImport = createFileRoute('/_main/metal/create')()
const MainDisksCreateLazyImport = createFileRoute('/_main/disks/create')()
const MainComputeCreateLazyImport = createFileRoute('/_main/compute/create')()
const MainBillingCreateLazyImport = createFileRoute('/_main/billing/create')()
const AdminMenuSimpleIndexLazyImport = createFileRoute(
  '/admin/_menu/_simple/',
)()
const AdminMenuSimpleVmimagesLazyImport = createFileRoute(
  '/admin/_menu/_simple/vm_images',
)()
const AdminMenuSimpleVmconfLazyImport = createFileRoute(
  '/admin/_menu/_simple/vm_conf',
)()
const AdminMenuSimpleTrackingLazyImport = createFileRoute(
  '/admin/_menu/_simple/tracking',
)()
const AdminMenuSimpleTestComponentsLazyImport = createFileRoute(
  '/admin/_menu/_simple/test-components',
)()
const AdminMenuSimpleStoragepoolsLazyImport = createFileRoute(
  '/admin/_menu/_simple/storage_pools',
)()
const AdminMenuSimpleReferralLazyImport = createFileRoute(
  '/admin/_menu/_simple/referral',
)()
const AdminMenuSimplePricesLazyImport = createFileRoute(
  '/admin/_menu/_simple/prices',
)()
const AdminMenuSimpleLocationsLazyImport = createFileRoute(
  '/admin/_menu/_simple/locations',
)()
const AdminMenuSimpleHostpoolsLazyImport = createFileRoute(
  '/admin/_menu/_simple/host_pools',
)()
const AdminMenuSimpleHelpLazyImport = createFileRoute(
  '/admin/_menu/_simple/help',
)()
const AdminMenuSimpleGeneralLazyImport = createFileRoute(
  '/admin/_menu/_simple/general',
)()
const AdminMenuSimpleCustomproductsLazyImport = createFileRoute(
  '/admin/_menu/_simple/custom_products',
)()
const AdminMenuSimpleCurrenciesLazyImport = createFileRoute(
  '/admin/_menu/_simple/currencies',
)()
const AdminMenuSimpleConfigurationLazyImport = createFileRoute(
  '/admin/_menu/_simple/configuration',
)()
const AdminMenuSimpleCampaignsLazyImport = createFileRoute(
  '/admin/_menu/_simple/campaigns',
)()
const AdminMenuSimpleAdminusersLazyImport = createFileRoute(
  '/admin/_menu/_simple/admin_users',
)()
const AdminMenuDualUsersLazyImport = createFileRoute(
  '/admin/_menu/_dual/users',
)()
const AdminMenuDualServicepackagesLazyImport = createFileRoute(
  '/admin/_menu/_dual/service_packages',
)()
const AdminMenuDualReportsLazyImport = createFileRoute(
  '/admin/_menu/_dual/reports',
)()
const AdminMenuDualLoadbalancersLazyImport = createFileRoute(
  '/admin/_menu/_dual/load_balancers',
)()
const AdminMenuDualHostsLazyImport = createFileRoute(
  '/admin/_menu/_dual/hosts',
)()
const AdminMenuDualFloatingipsLazyImport = createFileRoute(
  '/admin/_menu/_dual/floating_ips',
)()
const AdminMenuDualBucketsLazyImport = createFileRoute(
  '/admin/_menu/_dual/buckets',
)()
const AdminMenuDualAccountsLazyImport = createFileRoute(
  '/admin/_menu/_dual/accounts',
)()
const MaincustomConsoleLocationVmIdLazyImport = createFileRoute(
  '/_main_custom/console/$location/$vmId',
)()
const MainNetworkCreateTypeLazyImport = createFileRoute(
  '/_main/network/create/$type',
)()
const MainAccessCreateTypeLazyImport = createFileRoute(
  '/_main/access/create/$type',
)()
const MainStorageBucketStorageNameIndexLazyImport = createFileRoute(
  '/_main/storage/bucket/$storageName/',
)()
const MainStorageAccountAccountUuidIndexLazyImport = createFileRoute(
  '/_main/storage/account/$accountUuid/',
)()
const MainBillingAccountIdIndexLazyImport = createFileRoute(
  '/_main/billing/account/$id/',
)()
const MainAccessTokenIdIndexLazyImport = createFileRoute(
  '/_main/access/token/$id/',
)()
const MainAccessDelegationIdIndexLazyImport = createFileRoute(
  '/_main/access/delegation/$id/',
)()
const AdminMenuSimpleMetalSpecsLazyImport = createFileRoute(
  '/admin/_menu/_simple/metal/specs',
)()
const AdminMenuSimpleMetalOsLazyImport = createFileRoute(
  '/admin/_menu/_simple/metal/os',
)()
const MaincustomAdminConsoleLocationVmIdLazyImport = createFileRoute(
  '/_main_custom/admin/console/$location/$vmId',
)()
const MainBillingAccountIdEditLazyImport = createFileRoute(
  '/_main/billing/account/$id/edit',
)()
const AdminMenuSimpleMetalMachinesIndexLazyImport = createFileRoute(
  '/admin/_menu/_simple/metal/machines/',
)()
const MainServicesServiceLocationServiceIdIndexLazyImport = createFileRoute(
  '/_main/services/service/$location/$serviceId/',
)()
const MainNetworkVpcLocationUuidIndexLazyImport = createFileRoute(
  '/_main/network/vpc/$location/$uuid/',
)()
const MainNetworkLoadbalancerLocationUuidIndexLazyImport = createFileRoute(
  '/_main/network/load_balancer/$location/$uuid/',
)()
const MainNetworkIpaddressLocationUuidIndexLazyImport = createFileRoute(
  '/_main/network/ip_address/$location/$uuid/',
)()
const MainNetworkFirewallLocationUuidIndexLazyImport = createFileRoute(
  '/_main/network/firewall/$location/$uuid/',
)()
const MainMetalLeaseLocationUuidIndexLazyImport = createFileRoute(
  '/_main/metal/lease/$location/$uuid/',
)()
const MainDisksDiskLocationUuidIndexLazyImport = createFileRoute(
  '/_main/disks/disk/$location/$uuid/',
)()
const MainComputeVmLocationVmIdIndexLazyImport = createFileRoute(
  '/_main/compute/vm/$location/$vmId/',
)()
const MainBillingAccountIdDetailTypeInvoiceIdLazyImport = createFileRoute(
  '/_main/billing/account/$id/detail/$type/$invoiceId',
)()
const AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyImport =
  createFileRoute(
    '/admin/_menu/_simple/metal/machines/history/$location/$uuid',
  )()

// Create/Update Routes

const AdminLazyRoute = AdminLazyImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/admin.lazy').then((d) => d.Route))

const MaincustomLazyRoute = MaincustomLazyImport.update({
  id: '/_main_custom',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/_main_custom.lazy').then((d) => d.Route))

const PaymentreturnRoute = PaymentreturnImport.update({
  id: '/payment_return',
  path: '/payment_return',
  getParentRoute: () => rootRoute,
} as any)

const EmailverificationRoute = EmailverificationImport.update({
  id: '/email_verification',
  path: '/email_verification',
  getParentRoute: () => rootRoute,
} as any)

const ConsentformRoute = ConsentformImport.update({
  id: '/consent_form',
  path: '/consent_form',
  getParentRoute: () => rootRoute,
} as any)

const Auth0callbackRoute = Auth0callbackImport.update({
  id: '/auth0_callback',
  path: '/auth0_callback',
  getParentRoute: () => rootRoute,
} as any)

const MainRoute = MainImport.update({
  id: '/_main',
  getParentRoute: () => rootRoute,
} as any)

const MainIndexLazyRoute = MainIndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainRoute,
} as any).lazy(() => import('./routes/_main/index.lazy').then((d) => d.Route))

const AdminMenuLazyRoute = AdminMenuLazyImport.update({
  id: '/_menu',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() => import('./routes/admin/_menu.lazy').then((d) => d.Route))

const MaincustomAboutLazyRoute = MaincustomAboutLazyImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => MaincustomLazyRoute,
} as any).lazy(() =>
  import('./routes/_main_custom/about.lazy').then((d) => d.Route),
)

const MainTestErrorLazyRoute = MainTestErrorLazyImport.update({
  id: '/test-error',
  path: '/test-error',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/test-error.lazy').then((d) => d.Route),
)

const MainProfileIndexLazyRoute = MainProfileIndexLazyImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/profile/index.lazy').then((d) => d.Route),
)

const AdminMenuSimpleLazyRoute = AdminMenuSimpleLazyImport.update({
  id: '/_simple',
  getParentRoute: () => AdminMenuLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/_menu/_simple.lazy').then((d) => d.Route),
)

const MainStorageCreateLazyRoute = MainStorageCreateLazyImport.update({
  id: '/storage/create',
  path: '/storage/create',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/storage/create.lazy').then((d) => d.Route),
)

const MainSectionNameLazyRoute = MainSectionNameLazyImport.update({
  id: '/section/$name',
  path: '/section/$name',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/section/$name.lazy').then((d) => d.Route),
)

const MainMetalCreateLazyRoute = MainMetalCreateLazyImport.update({
  id: '/metal/create',
  path: '/metal/create',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/metal/create.lazy').then((d) => d.Route),
)

const MainDisksCreateLazyRoute = MainDisksCreateLazyImport.update({
  id: '/disks/create',
  path: '/disks/create',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/disks/create.lazy').then((d) => d.Route),
)

const MainComputeCreateLazyRoute = MainComputeCreateLazyImport.update({
  id: '/compute/create',
  path: '/compute/create',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/compute/create.lazy').then((d) => d.Route),
)

const MainBillingCreateLazyRoute = MainBillingCreateLazyImport.update({
  id: '/billing/create',
  path: '/billing/create',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/billing/create.lazy').then((d) => d.Route),
)

const MainServicesCreateRoute = MainServicesCreateImport.update({
  id: '/services/create',
  path: '/services/create',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/services/create.lazy').then((d) => d.Route),
)

const AdminMenuSimpleIndexLazyRoute = AdminMenuSimpleIndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminMenuSimpleLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/_menu/_simple/index.lazy').then((d) => d.Route),
)

const MainNetworkCreateIndexRoute = MainNetworkCreateIndexImport.update({
  id: '/network/create/',
  path: '/network/create/',
  getParentRoute: () => MainRoute,
} as any)

const AdminMenuSimpleVmimagesLazyRoute =
  AdminMenuSimpleVmimagesLazyImport.update({
    id: '/vm_images',
    path: '/vm_images',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/vm_images.lazy').then((d) => d.Route),
  )

const AdminMenuSimpleVmconfLazyRoute = AdminMenuSimpleVmconfLazyImport.update({
  id: '/vm_conf',
  path: '/vm_conf',
  getParentRoute: () => AdminMenuSimpleLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/_menu/_simple/vm_conf.lazy').then((d) => d.Route),
)

const AdminMenuSimpleTrackingLazyRoute =
  AdminMenuSimpleTrackingLazyImport.update({
    id: '/tracking',
    path: '/tracking',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/tracking.lazy').then((d) => d.Route),
  )

const AdminMenuSimpleTestComponentsLazyRoute =
  AdminMenuSimpleTestComponentsLazyImport.update({
    id: '/test-components',
    path: '/test-components',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/test-components.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminMenuSimpleStoragepoolsLazyRoute =
  AdminMenuSimpleStoragepoolsLazyImport.update({
    id: '/storage_pools',
    path: '/storage_pools',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/storage_pools.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminMenuSimpleReferralLazyRoute =
  AdminMenuSimpleReferralLazyImport.update({
    id: '/referral',
    path: '/referral',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/referral.lazy').then((d) => d.Route),
  )

const AdminMenuSimplePricesLazyRoute = AdminMenuSimplePricesLazyImport.update({
  id: '/prices',
  path: '/prices',
  getParentRoute: () => AdminMenuSimpleLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/_menu/_simple/prices.lazy').then((d) => d.Route),
)

const AdminMenuSimpleLocationsLazyRoute =
  AdminMenuSimpleLocationsLazyImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/locations.lazy').then((d) => d.Route),
  )

const AdminMenuSimpleHostpoolsLazyRoute =
  AdminMenuSimpleHostpoolsLazyImport.update({
    id: '/host_pools',
    path: '/host_pools',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/host_pools.lazy').then((d) => d.Route),
  )

const AdminMenuSimpleHelpLazyRoute = AdminMenuSimpleHelpLazyImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AdminMenuSimpleLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/_menu/_simple/help.lazy').then((d) => d.Route),
)

const AdminMenuSimpleGeneralLazyRoute = AdminMenuSimpleGeneralLazyImport.update(
  {
    id: '/general',
    path: '/general',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any,
).lazy(() =>
  import('./routes/admin/_menu/_simple/general.lazy').then((d) => d.Route),
)

const AdminMenuSimpleCustomproductsLazyRoute =
  AdminMenuSimpleCustomproductsLazyImport.update({
    id: '/custom_products',
    path: '/custom_products',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/custom_products.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminMenuSimpleCurrenciesLazyRoute =
  AdminMenuSimpleCurrenciesLazyImport.update({
    id: '/currencies',
    path: '/currencies',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/currencies.lazy').then((d) => d.Route),
  )

const AdminMenuSimpleConfigurationLazyRoute =
  AdminMenuSimpleConfigurationLazyImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/configuration.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminMenuSimpleCampaignsLazyRoute =
  AdminMenuSimpleCampaignsLazyImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/campaigns.lazy').then((d) => d.Route),
  )

const AdminMenuSimpleAdminusersLazyRoute =
  AdminMenuSimpleAdminusersLazyImport.update({
    id: '/admin_users',
    path: '/admin_users',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/admin_users.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminMenuDualUsersLazyRoute = AdminMenuDualUsersLazyImport.update({
  id: '/_dual/users',
  path: '/users',
  getParentRoute: () => AdminMenuLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/_menu/_dual/users.lazy').then((d) => d.Route),
)

const AdminMenuDualServicepackagesLazyRoute =
  AdminMenuDualServicepackagesLazyImport.update({
    id: '/_dual/service_packages',
    path: '/service_packages',
    getParentRoute: () => AdminMenuLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_dual/service_packages.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminMenuDualReportsLazyRoute = AdminMenuDualReportsLazyImport.update({
  id: '/_dual/reports',
  path: '/reports',
  getParentRoute: () => AdminMenuLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/_menu/_dual/reports.lazy').then((d) => d.Route),
)

const AdminMenuDualLoadbalancersLazyRoute =
  AdminMenuDualLoadbalancersLazyImport.update({
    id: '/_dual/load_balancers',
    path: '/load_balancers',
    getParentRoute: () => AdminMenuLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_dual/load_balancers.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminMenuDualHostsLazyRoute = AdminMenuDualHostsLazyImport.update({
  id: '/_dual/hosts',
  path: '/hosts',
  getParentRoute: () => AdminMenuLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/_menu/_dual/hosts.lazy').then((d) => d.Route),
)

const AdminMenuDualFloatingipsLazyRoute =
  AdminMenuDualFloatingipsLazyImport.update({
    id: '/_dual/floating_ips',
    path: '/floating_ips',
    getParentRoute: () => AdminMenuLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_dual/floating_ips.lazy').then((d) => d.Route),
  )

const AdminMenuDualBucketsLazyRoute = AdminMenuDualBucketsLazyImport.update({
  id: '/_dual/buckets',
  path: '/buckets',
  getParentRoute: () => AdminMenuLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/_menu/_dual/buckets.lazy').then((d) => d.Route),
)

const AdminMenuDualAccountsLazyRoute = AdminMenuDualAccountsLazyImport.update({
  id: '/_dual/accounts',
  path: '/accounts',
  getParentRoute: () => AdminMenuLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/_menu/_dual/accounts.lazy').then((d) => d.Route),
)

const MaincustomConsoleLocationVmIdLazyRoute =
  MaincustomConsoleLocationVmIdLazyImport.update({
    id: '/console/$location/$vmId',
    path: '/console/$location/$vmId',
    getParentRoute: () => MaincustomLazyRoute,
  } as any).lazy(() =>
    import('./routes/_main_custom/console.$location.$vmId.lazy').then(
      (d) => d.Route,
    ),
  )

const MainNetworkCreateTypeLazyRoute = MainNetworkCreateTypeLazyImport.update({
  id: '/network/create/$type',
  path: '/network/create/$type',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/network/create.$type.lazy').then((d) => d.Route),
)

const MainAccessCreateTypeLazyRoute = MainAccessCreateTypeLazyImport.update({
  id: '/access/create/$type',
  path: '/access/create/$type',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/access/create.$type.lazy').then((d) => d.Route),
)

const AdminMenuDualVirtualmachinesRouteRoute =
  AdminMenuDualVirtualmachinesRouteImport.update({
    id: '/_dual/virtual_machines',
    path: '/virtual_machines',
    getParentRoute: () => AdminMenuLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_dual/virtual_machines.lazy').then(
      (d) => d.Route,
    ),
  )

const MainStorageBucketStorageNameIndexLazyRoute =
  MainStorageBucketStorageNameIndexLazyImport.update({
    id: '/storage/bucket/$storageName/',
    path: '/storage/bucket/$storageName/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/storage/bucket.$storageName/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainStorageAccountAccountUuidIndexLazyRoute =
  MainStorageAccountAccountUuidIndexLazyImport.update({
    id: '/storage/account/$accountUuid/',
    path: '/storage/account/$accountUuid/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/storage/account.$accountUuid/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainBillingAccountIdIndexLazyRoute =
  MainBillingAccountIdIndexLazyImport.update({
    id: '/billing/account/$id/',
    path: '/billing/account/$id/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/billing/account.$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainAccessTokenIdIndexLazyRoute = MainAccessTokenIdIndexLazyImport.update(
  {
    id: '/access/token/$id/',
    path: '/access/token/$id/',
    getParentRoute: () => MainRoute,
  } as any,
).lazy(() =>
  import('./routes/_main/access/token/$id/index.lazy').then((d) => d.Route),
)

const MainAccessDelegationIdIndexLazyRoute =
  MainAccessDelegationIdIndexLazyImport.update({
    id: '/access/delegation/$id/',
    path: '/access/delegation/$id/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/access/delegation/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminMenuSimpleMetalSpecsLazyRoute =
  AdminMenuSimpleMetalSpecsLazyImport.update({
    id: '/metal/specs',
    path: '/metal/specs',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/metal/specs.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminMenuSimpleMetalOsLazyRoute = AdminMenuSimpleMetalOsLazyImport.update(
  {
    id: '/metal/os',
    path: '/metal/os',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any,
).lazy(() =>
  import('./routes/admin/_menu/_simple/metal/os.lazy').then((d) => d.Route),
)

const MaincustomAdminConsoleLocationVmIdLazyRoute =
  MaincustomAdminConsoleLocationVmIdLazyImport.update({
    id: '/admin/console/$location/$vmId',
    path: '/admin/console/$location/$vmId',
    getParentRoute: () => MaincustomLazyRoute,
  } as any).lazy(() =>
    import('./routes/_main_custom/admin/console.$location.$vmId.lazy').then(
      (d) => d.Route,
    ),
  )

const MainBillingAccountIdEditLazyRoute =
  MainBillingAccountIdEditLazyImport.update({
    id: '/billing/account/$id/edit',
    path: '/billing/account/$id/edit',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/billing/account.$id/edit.lazy').then((d) => d.Route),
  )

const AdminMenuSimpleMetalMachinesIndexLazyRoute =
  AdminMenuSimpleMetalMachinesIndexLazyImport.update({
    id: '/metal/machines/',
    path: '/metal/machines/',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/metal/machines/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainServicesServiceLocationServiceIdIndexLazyRoute =
  MainServicesServiceLocationServiceIdIndexLazyImport.update({
    id: '/services/service/$location/$serviceId/',
    path: '/services/service/$location/$serviceId/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/services/service.$location.$serviceId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainNetworkVpcLocationUuidIndexLazyRoute =
  MainNetworkVpcLocationUuidIndexLazyImport.update({
    id: '/network/vpc/$location/$uuid/',
    path: '/network/vpc/$location/$uuid/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/network/vpc/$location/$uuid/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainNetworkLoadbalancerLocationUuidIndexLazyRoute =
  MainNetworkLoadbalancerLocationUuidIndexLazyImport.update({
    id: '/network/load_balancer/$location/$uuid/',
    path: '/network/load_balancer/$location/$uuid/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/network/load_balancer/$location/$uuid/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainNetworkIpaddressLocationUuidIndexLazyRoute =
  MainNetworkIpaddressLocationUuidIndexLazyImport.update({
    id: '/network/ip_address/$location/$uuid/',
    path: '/network/ip_address/$location/$uuid/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/network/ip_address/$location/$uuid/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainNetworkFirewallLocationUuidIndexLazyRoute =
  MainNetworkFirewallLocationUuidIndexLazyImport.update({
    id: '/network/firewall/$location/$uuid/',
    path: '/network/firewall/$location/$uuid/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/network/firewall/$location/$uuid/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainMetalLeaseLocationUuidIndexLazyRoute =
  MainMetalLeaseLocationUuidIndexLazyImport.update({
    id: '/metal/lease/$location/$uuid/',
    path: '/metal/lease/$location/$uuid/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/metal/lease.$location.$uuid/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainDisksDiskLocationUuidIndexLazyRoute =
  MainDisksDiskLocationUuidIndexLazyImport.update({
    id: '/disks/disk/$location/$uuid/',
    path: '/disks/disk/$location/$uuid/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/disks/disk/$location/$uuid/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainComputeVmLocationVmIdIndexLazyRoute =
  MainComputeVmLocationVmIdIndexLazyImport.update({
    id: '/compute/vm/$location/$vmId/',
    path: '/compute/vm/$location/$vmId/',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/compute/vm.$location.$vmId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const MainBillingAccountIdDetailTypeInvoiceIdLazyRoute =
  MainBillingAccountIdDetailTypeInvoiceIdLazyImport.update({
    id: '/billing/account/$id/detail/$type/$invoiceId',
    path: '/billing/account/$id/detail/$type/$invoiceId',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/billing/account.$id/detail.$type.$invoiceId.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyRoute =
  AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyImport.update({
    id: '/metal/machines/history/$location/$uuid',
    path: '/metal/machines/history/$location/$uuid',
    getParentRoute: () => AdminMenuSimpleLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/_menu/_simple/metal/machines/history.$location.$uuid.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainImport
      parentRoute: typeof rootRoute
    }
    '/auth0_callback': {
      id: '/auth0_callback'
      path: '/auth0_callback'
      fullPath: '/auth0_callback'
      preLoaderRoute: typeof Auth0callbackImport
      parentRoute: typeof rootRoute
    }
    '/consent_form': {
      id: '/consent_form'
      path: '/consent_form'
      fullPath: '/consent_form'
      preLoaderRoute: typeof ConsentformImport
      parentRoute: typeof rootRoute
    }
    '/email_verification': {
      id: '/email_verification'
      path: '/email_verification'
      fullPath: '/email_verification'
      preLoaderRoute: typeof EmailverificationImport
      parentRoute: typeof rootRoute
    }
    '/payment_return': {
      id: '/payment_return'
      path: '/payment_return'
      fullPath: '/payment_return'
      preLoaderRoute: typeof PaymentreturnImport
      parentRoute: typeof rootRoute
    }
    '/_main_custom': {
      id: '/_main_custom'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MaincustomLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminLazyImport
      parentRoute: typeof rootRoute
    }
    '/_main/test-error': {
      id: '/_main/test-error'
      path: '/test-error'
      fullPath: '/test-error'
      preLoaderRoute: typeof MainTestErrorLazyImport
      parentRoute: typeof MainImport
    }
    '/_main_custom/about': {
      id: '/_main_custom/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof MaincustomAboutLazyImport
      parentRoute: typeof MaincustomLazyImport
    }
    '/admin/_menu': {
      id: '/admin/_menu'
      path: ''
      fullPath: '/admin'
      preLoaderRoute: typeof AdminMenuLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/_main/': {
      id: '/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/services/create': {
      id: '/_main/services/create'
      path: '/services/create'
      fullPath: '/services/create'
      preLoaderRoute: typeof MainServicesCreateImport
      parentRoute: typeof MainImport
    }
    '/_main/billing/create': {
      id: '/_main/billing/create'
      path: '/billing/create'
      fullPath: '/billing/create'
      preLoaderRoute: typeof MainBillingCreateLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/compute/create': {
      id: '/_main/compute/create'
      path: '/compute/create'
      fullPath: '/compute/create'
      preLoaderRoute: typeof MainComputeCreateLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/disks/create': {
      id: '/_main/disks/create'
      path: '/disks/create'
      fullPath: '/disks/create'
      preLoaderRoute: typeof MainDisksCreateLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/metal/create': {
      id: '/_main/metal/create'
      path: '/metal/create'
      fullPath: '/metal/create'
      preLoaderRoute: typeof MainMetalCreateLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/section/$name': {
      id: '/_main/section/$name'
      path: '/section/$name'
      fullPath: '/section/$name'
      preLoaderRoute: typeof MainSectionNameLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/storage/create': {
      id: '/_main/storage/create'
      path: '/storage/create'
      fullPath: '/storage/create'
      preLoaderRoute: typeof MainStorageCreateLazyImport
      parentRoute: typeof MainImport
    }
    '/admin/_menu/_simple': {
      id: '/admin/_menu/_simple'
      path: ''
      fullPath: '/admin'
      preLoaderRoute: typeof AdminMenuSimpleLazyImport
      parentRoute: typeof AdminMenuLazyImport
    }
    '/_main/profile/': {
      id: '/_main/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof MainProfileIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/admin/_menu/_dual/virtual_machines': {
      id: '/admin/_menu/_dual/virtual_machines'
      path: '/virtual_machines'
      fullPath: '/admin/virtual_machines'
      preLoaderRoute: typeof AdminMenuDualVirtualmachinesRouteImport
      parentRoute: typeof AdminMenuLazyImport
    }
    '/_main/access/create/$type': {
      id: '/_main/access/create/$type'
      path: '/access/create/$type'
      fullPath: '/access/create/$type'
      preLoaderRoute: typeof MainAccessCreateTypeLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/network/create/$type': {
      id: '/_main/network/create/$type'
      path: '/network/create/$type'
      fullPath: '/network/create/$type'
      preLoaderRoute: typeof MainNetworkCreateTypeLazyImport
      parentRoute: typeof MainImport
    }
    '/_main_custom/console/$location/$vmId': {
      id: '/_main_custom/console/$location/$vmId'
      path: '/console/$location/$vmId'
      fullPath: '/console/$location/$vmId'
      preLoaderRoute: typeof MaincustomConsoleLocationVmIdLazyImport
      parentRoute: typeof MaincustomLazyImport
    }
    '/admin/_menu/_dual/accounts': {
      id: '/admin/_menu/_dual/accounts'
      path: '/accounts'
      fullPath: '/admin/accounts'
      preLoaderRoute: typeof AdminMenuDualAccountsLazyImport
      parentRoute: typeof AdminMenuLazyImport
    }
    '/admin/_menu/_dual/buckets': {
      id: '/admin/_menu/_dual/buckets'
      path: '/buckets'
      fullPath: '/admin/buckets'
      preLoaderRoute: typeof AdminMenuDualBucketsLazyImport
      parentRoute: typeof AdminMenuLazyImport
    }
    '/admin/_menu/_dual/floating_ips': {
      id: '/admin/_menu/_dual/floating_ips'
      path: '/floating_ips'
      fullPath: '/admin/floating_ips'
      preLoaderRoute: typeof AdminMenuDualFloatingipsLazyImport
      parentRoute: typeof AdminMenuLazyImport
    }
    '/admin/_menu/_dual/hosts': {
      id: '/admin/_menu/_dual/hosts'
      path: '/hosts'
      fullPath: '/admin/hosts'
      preLoaderRoute: typeof AdminMenuDualHostsLazyImport
      parentRoute: typeof AdminMenuLazyImport
    }
    '/admin/_menu/_dual/load_balancers': {
      id: '/admin/_menu/_dual/load_balancers'
      path: '/load_balancers'
      fullPath: '/admin/load_balancers'
      preLoaderRoute: typeof AdminMenuDualLoadbalancersLazyImport
      parentRoute: typeof AdminMenuLazyImport
    }
    '/admin/_menu/_dual/reports': {
      id: '/admin/_menu/_dual/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminMenuDualReportsLazyImport
      parentRoute: typeof AdminMenuLazyImport
    }
    '/admin/_menu/_dual/service_packages': {
      id: '/admin/_menu/_dual/service_packages'
      path: '/service_packages'
      fullPath: '/admin/service_packages'
      preLoaderRoute: typeof AdminMenuDualServicepackagesLazyImport
      parentRoute: typeof AdminMenuLazyImport
    }
    '/admin/_menu/_dual/users': {
      id: '/admin/_menu/_dual/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminMenuDualUsersLazyImport
      parentRoute: typeof AdminMenuLazyImport
    }
    '/admin/_menu/_simple/admin_users': {
      id: '/admin/_menu/_simple/admin_users'
      path: '/admin_users'
      fullPath: '/admin/admin_users'
      preLoaderRoute: typeof AdminMenuSimpleAdminusersLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/campaigns': {
      id: '/admin/_menu/_simple/campaigns'
      path: '/campaigns'
      fullPath: '/admin/campaigns'
      preLoaderRoute: typeof AdminMenuSimpleCampaignsLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/configuration': {
      id: '/admin/_menu/_simple/configuration'
      path: '/configuration'
      fullPath: '/admin/configuration'
      preLoaderRoute: typeof AdminMenuSimpleConfigurationLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/currencies': {
      id: '/admin/_menu/_simple/currencies'
      path: '/currencies'
      fullPath: '/admin/currencies'
      preLoaderRoute: typeof AdminMenuSimpleCurrenciesLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/custom_products': {
      id: '/admin/_menu/_simple/custom_products'
      path: '/custom_products'
      fullPath: '/admin/custom_products'
      preLoaderRoute: typeof AdminMenuSimpleCustomproductsLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/general': {
      id: '/admin/_menu/_simple/general'
      path: '/general'
      fullPath: '/admin/general'
      preLoaderRoute: typeof AdminMenuSimpleGeneralLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/help': {
      id: '/admin/_menu/_simple/help'
      path: '/help'
      fullPath: '/admin/help'
      preLoaderRoute: typeof AdminMenuSimpleHelpLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/host_pools': {
      id: '/admin/_menu/_simple/host_pools'
      path: '/host_pools'
      fullPath: '/admin/host_pools'
      preLoaderRoute: typeof AdminMenuSimpleHostpoolsLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/locations': {
      id: '/admin/_menu/_simple/locations'
      path: '/locations'
      fullPath: '/admin/locations'
      preLoaderRoute: typeof AdminMenuSimpleLocationsLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/prices': {
      id: '/admin/_menu/_simple/prices'
      path: '/prices'
      fullPath: '/admin/prices'
      preLoaderRoute: typeof AdminMenuSimplePricesLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/referral': {
      id: '/admin/_menu/_simple/referral'
      path: '/referral'
      fullPath: '/admin/referral'
      preLoaderRoute: typeof AdminMenuSimpleReferralLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/storage_pools': {
      id: '/admin/_menu/_simple/storage_pools'
      path: '/storage_pools'
      fullPath: '/admin/storage_pools'
      preLoaderRoute: typeof AdminMenuSimpleStoragepoolsLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/test-components': {
      id: '/admin/_menu/_simple/test-components'
      path: '/test-components'
      fullPath: '/admin/test-components'
      preLoaderRoute: typeof AdminMenuSimpleTestComponentsLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/tracking': {
      id: '/admin/_menu/_simple/tracking'
      path: '/tracking'
      fullPath: '/admin/tracking'
      preLoaderRoute: typeof AdminMenuSimpleTrackingLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/vm_conf': {
      id: '/admin/_menu/_simple/vm_conf'
      path: '/vm_conf'
      fullPath: '/admin/vm_conf'
      preLoaderRoute: typeof AdminMenuSimpleVmconfLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/vm_images': {
      id: '/admin/_menu/_simple/vm_images'
      path: '/vm_images'
      fullPath: '/admin/vm_images'
      preLoaderRoute: typeof AdminMenuSimpleVmimagesLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/_main/network/create/': {
      id: '/_main/network/create/'
      path: '/network/create'
      fullPath: '/network/create'
      preLoaderRoute: typeof MainNetworkCreateIndexImport
      parentRoute: typeof MainImport
    }
    '/admin/_menu/_simple/': {
      id: '/admin/_menu/_simple/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminMenuSimpleIndexLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/_main/billing/account/$id/edit': {
      id: '/_main/billing/account/$id/edit'
      path: '/billing/account/$id/edit'
      fullPath: '/billing/account/$id/edit'
      preLoaderRoute: typeof MainBillingAccountIdEditLazyImport
      parentRoute: typeof MainImport
    }
    '/_main_custom/admin/console/$location/$vmId': {
      id: '/_main_custom/admin/console/$location/$vmId'
      path: '/admin/console/$location/$vmId'
      fullPath: '/admin/console/$location/$vmId'
      preLoaderRoute: typeof MaincustomAdminConsoleLocationVmIdLazyImport
      parentRoute: typeof MaincustomLazyImport
    }
    '/admin/_menu/_simple/metal/os': {
      id: '/admin/_menu/_simple/metal/os'
      path: '/metal/os'
      fullPath: '/admin/metal/os'
      preLoaderRoute: typeof AdminMenuSimpleMetalOsLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/admin/_menu/_simple/metal/specs': {
      id: '/admin/_menu/_simple/metal/specs'
      path: '/metal/specs'
      fullPath: '/admin/metal/specs'
      preLoaderRoute: typeof AdminMenuSimpleMetalSpecsLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/_main/access/delegation/$id/': {
      id: '/_main/access/delegation/$id/'
      path: '/access/delegation/$id'
      fullPath: '/access/delegation/$id'
      preLoaderRoute: typeof MainAccessDelegationIdIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/access/token/$id/': {
      id: '/_main/access/token/$id/'
      path: '/access/token/$id'
      fullPath: '/access/token/$id'
      preLoaderRoute: typeof MainAccessTokenIdIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/billing/account/$id/': {
      id: '/_main/billing/account/$id/'
      path: '/billing/account/$id'
      fullPath: '/billing/account/$id'
      preLoaderRoute: typeof MainBillingAccountIdIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/storage/account/$accountUuid/': {
      id: '/_main/storage/account/$accountUuid/'
      path: '/storage/account/$accountUuid'
      fullPath: '/storage/account/$accountUuid'
      preLoaderRoute: typeof MainStorageAccountAccountUuidIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/storage/bucket/$storageName/': {
      id: '/_main/storage/bucket/$storageName/'
      path: '/storage/bucket/$storageName'
      fullPath: '/storage/bucket/$storageName'
      preLoaderRoute: typeof MainStorageBucketStorageNameIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/compute/vm/$location/$vmId/': {
      id: '/_main/compute/vm/$location/$vmId/'
      path: '/compute/vm/$location/$vmId'
      fullPath: '/compute/vm/$location/$vmId'
      preLoaderRoute: typeof MainComputeVmLocationVmIdIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/disks/disk/$location/$uuid/': {
      id: '/_main/disks/disk/$location/$uuid/'
      path: '/disks/disk/$location/$uuid'
      fullPath: '/disks/disk/$location/$uuid'
      preLoaderRoute: typeof MainDisksDiskLocationUuidIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/metal/lease/$location/$uuid/': {
      id: '/_main/metal/lease/$location/$uuid/'
      path: '/metal/lease/$location/$uuid'
      fullPath: '/metal/lease/$location/$uuid'
      preLoaderRoute: typeof MainMetalLeaseLocationUuidIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/network/firewall/$location/$uuid/': {
      id: '/_main/network/firewall/$location/$uuid/'
      path: '/network/firewall/$location/$uuid'
      fullPath: '/network/firewall/$location/$uuid'
      preLoaderRoute: typeof MainNetworkFirewallLocationUuidIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/network/ip_address/$location/$uuid/': {
      id: '/_main/network/ip_address/$location/$uuid/'
      path: '/network/ip_address/$location/$uuid'
      fullPath: '/network/ip_address/$location/$uuid'
      preLoaderRoute: typeof MainNetworkIpaddressLocationUuidIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/network/load_balancer/$location/$uuid/': {
      id: '/_main/network/load_balancer/$location/$uuid/'
      path: '/network/load_balancer/$location/$uuid'
      fullPath: '/network/load_balancer/$location/$uuid'
      preLoaderRoute: typeof MainNetworkLoadbalancerLocationUuidIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/network/vpc/$location/$uuid/': {
      id: '/_main/network/vpc/$location/$uuid/'
      path: '/network/vpc/$location/$uuid'
      fullPath: '/network/vpc/$location/$uuid'
      preLoaderRoute: typeof MainNetworkVpcLocationUuidIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/services/service/$location/$serviceId/': {
      id: '/_main/services/service/$location/$serviceId/'
      path: '/services/service/$location/$serviceId'
      fullPath: '/services/service/$location/$serviceId'
      preLoaderRoute: typeof MainServicesServiceLocationServiceIdIndexLazyImport
      parentRoute: typeof MainImport
    }
    '/admin/_menu/_simple/metal/machines/': {
      id: '/admin/_menu/_simple/metal/machines/'
      path: '/metal/machines'
      fullPath: '/admin/metal/machines'
      preLoaderRoute: typeof AdminMenuSimpleMetalMachinesIndexLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
    '/_main/billing/account/$id/detail/$type/$invoiceId': {
      id: '/_main/billing/account/$id/detail/$type/$invoiceId'
      path: '/billing/account/$id/detail/$type/$invoiceId'
      fullPath: '/billing/account/$id/detail/$type/$invoiceId'
      preLoaderRoute: typeof MainBillingAccountIdDetailTypeInvoiceIdLazyImport
      parentRoute: typeof MainImport
    }
    '/admin/_menu/_simple/metal/machines/history/$location/$uuid': {
      id: '/admin/_menu/_simple/metal/machines/history/$location/$uuid'
      path: '/metal/machines/history/$location/$uuid'
      fullPath: '/admin/metal/machines/history/$location/$uuid'
      preLoaderRoute: typeof AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyImport
      parentRoute: typeof AdminMenuSimpleLazyImport
    }
  }
}

// Create and export the route tree

interface MainRouteChildren {
  MainTestErrorLazyRoute: typeof MainTestErrorLazyRoute
  MainIndexLazyRoute: typeof MainIndexLazyRoute
  MainServicesCreateRoute: typeof MainServicesCreateRoute
  MainBillingCreateLazyRoute: typeof MainBillingCreateLazyRoute
  MainComputeCreateLazyRoute: typeof MainComputeCreateLazyRoute
  MainDisksCreateLazyRoute: typeof MainDisksCreateLazyRoute
  MainMetalCreateLazyRoute: typeof MainMetalCreateLazyRoute
  MainSectionNameLazyRoute: typeof MainSectionNameLazyRoute
  MainStorageCreateLazyRoute: typeof MainStorageCreateLazyRoute
  MainProfileIndexLazyRoute: typeof MainProfileIndexLazyRoute
  MainAccessCreateTypeLazyRoute: typeof MainAccessCreateTypeLazyRoute
  MainNetworkCreateTypeLazyRoute: typeof MainNetworkCreateTypeLazyRoute
  MainNetworkCreateIndexRoute: typeof MainNetworkCreateIndexRoute
  MainBillingAccountIdEditLazyRoute: typeof MainBillingAccountIdEditLazyRoute
  MainAccessDelegationIdIndexLazyRoute: typeof MainAccessDelegationIdIndexLazyRoute
  MainAccessTokenIdIndexLazyRoute: typeof MainAccessTokenIdIndexLazyRoute
  MainBillingAccountIdIndexLazyRoute: typeof MainBillingAccountIdIndexLazyRoute
  MainStorageAccountAccountUuidIndexLazyRoute: typeof MainStorageAccountAccountUuidIndexLazyRoute
  MainStorageBucketStorageNameIndexLazyRoute: typeof MainStorageBucketStorageNameIndexLazyRoute
  MainComputeVmLocationVmIdIndexLazyRoute: typeof MainComputeVmLocationVmIdIndexLazyRoute
  MainDisksDiskLocationUuidIndexLazyRoute: typeof MainDisksDiskLocationUuidIndexLazyRoute
  MainMetalLeaseLocationUuidIndexLazyRoute: typeof MainMetalLeaseLocationUuidIndexLazyRoute
  MainNetworkFirewallLocationUuidIndexLazyRoute: typeof MainNetworkFirewallLocationUuidIndexLazyRoute
  MainNetworkIpaddressLocationUuidIndexLazyRoute: typeof MainNetworkIpaddressLocationUuidIndexLazyRoute
  MainNetworkLoadbalancerLocationUuidIndexLazyRoute: typeof MainNetworkLoadbalancerLocationUuidIndexLazyRoute
  MainNetworkVpcLocationUuidIndexLazyRoute: typeof MainNetworkVpcLocationUuidIndexLazyRoute
  MainServicesServiceLocationServiceIdIndexLazyRoute: typeof MainServicesServiceLocationServiceIdIndexLazyRoute
  MainBillingAccountIdDetailTypeInvoiceIdLazyRoute: typeof MainBillingAccountIdDetailTypeInvoiceIdLazyRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainTestErrorLazyRoute: MainTestErrorLazyRoute,
  MainIndexLazyRoute: MainIndexLazyRoute,
  MainServicesCreateRoute: MainServicesCreateRoute,
  MainBillingCreateLazyRoute: MainBillingCreateLazyRoute,
  MainComputeCreateLazyRoute: MainComputeCreateLazyRoute,
  MainDisksCreateLazyRoute: MainDisksCreateLazyRoute,
  MainMetalCreateLazyRoute: MainMetalCreateLazyRoute,
  MainSectionNameLazyRoute: MainSectionNameLazyRoute,
  MainStorageCreateLazyRoute: MainStorageCreateLazyRoute,
  MainProfileIndexLazyRoute: MainProfileIndexLazyRoute,
  MainAccessCreateTypeLazyRoute: MainAccessCreateTypeLazyRoute,
  MainNetworkCreateTypeLazyRoute: MainNetworkCreateTypeLazyRoute,
  MainNetworkCreateIndexRoute: MainNetworkCreateIndexRoute,
  MainBillingAccountIdEditLazyRoute: MainBillingAccountIdEditLazyRoute,
  MainAccessDelegationIdIndexLazyRoute: MainAccessDelegationIdIndexLazyRoute,
  MainAccessTokenIdIndexLazyRoute: MainAccessTokenIdIndexLazyRoute,
  MainBillingAccountIdIndexLazyRoute: MainBillingAccountIdIndexLazyRoute,
  MainStorageAccountAccountUuidIndexLazyRoute:
    MainStorageAccountAccountUuidIndexLazyRoute,
  MainStorageBucketStorageNameIndexLazyRoute:
    MainStorageBucketStorageNameIndexLazyRoute,
  MainComputeVmLocationVmIdIndexLazyRoute:
    MainComputeVmLocationVmIdIndexLazyRoute,
  MainDisksDiskLocationUuidIndexLazyRoute:
    MainDisksDiskLocationUuidIndexLazyRoute,
  MainMetalLeaseLocationUuidIndexLazyRoute:
    MainMetalLeaseLocationUuidIndexLazyRoute,
  MainNetworkFirewallLocationUuidIndexLazyRoute:
    MainNetworkFirewallLocationUuidIndexLazyRoute,
  MainNetworkIpaddressLocationUuidIndexLazyRoute:
    MainNetworkIpaddressLocationUuidIndexLazyRoute,
  MainNetworkLoadbalancerLocationUuidIndexLazyRoute:
    MainNetworkLoadbalancerLocationUuidIndexLazyRoute,
  MainNetworkVpcLocationUuidIndexLazyRoute:
    MainNetworkVpcLocationUuidIndexLazyRoute,
  MainServicesServiceLocationServiceIdIndexLazyRoute:
    MainServicesServiceLocationServiceIdIndexLazyRoute,
  MainBillingAccountIdDetailTypeInvoiceIdLazyRoute:
    MainBillingAccountIdDetailTypeInvoiceIdLazyRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

interface MaincustomLazyRouteChildren {
  MaincustomAboutLazyRoute: typeof MaincustomAboutLazyRoute
  MaincustomConsoleLocationVmIdLazyRoute: typeof MaincustomConsoleLocationVmIdLazyRoute
  MaincustomAdminConsoleLocationVmIdLazyRoute: typeof MaincustomAdminConsoleLocationVmIdLazyRoute
}

const MaincustomLazyRouteChildren: MaincustomLazyRouteChildren = {
  MaincustomAboutLazyRoute: MaincustomAboutLazyRoute,
  MaincustomConsoleLocationVmIdLazyRoute:
    MaincustomConsoleLocationVmIdLazyRoute,
  MaincustomAdminConsoleLocationVmIdLazyRoute:
    MaincustomAdminConsoleLocationVmIdLazyRoute,
}

const MaincustomLazyRouteWithChildren = MaincustomLazyRoute._addFileChildren(
  MaincustomLazyRouteChildren,
)

interface AdminMenuSimpleLazyRouteChildren {
  AdminMenuSimpleAdminusersLazyRoute: typeof AdminMenuSimpleAdminusersLazyRoute
  AdminMenuSimpleCampaignsLazyRoute: typeof AdminMenuSimpleCampaignsLazyRoute
  AdminMenuSimpleConfigurationLazyRoute: typeof AdminMenuSimpleConfigurationLazyRoute
  AdminMenuSimpleCurrenciesLazyRoute: typeof AdminMenuSimpleCurrenciesLazyRoute
  AdminMenuSimpleCustomproductsLazyRoute: typeof AdminMenuSimpleCustomproductsLazyRoute
  AdminMenuSimpleGeneralLazyRoute: typeof AdminMenuSimpleGeneralLazyRoute
  AdminMenuSimpleHelpLazyRoute: typeof AdminMenuSimpleHelpLazyRoute
  AdminMenuSimpleHostpoolsLazyRoute: typeof AdminMenuSimpleHostpoolsLazyRoute
  AdminMenuSimpleLocationsLazyRoute: typeof AdminMenuSimpleLocationsLazyRoute
  AdminMenuSimplePricesLazyRoute: typeof AdminMenuSimplePricesLazyRoute
  AdminMenuSimpleReferralLazyRoute: typeof AdminMenuSimpleReferralLazyRoute
  AdminMenuSimpleStoragepoolsLazyRoute: typeof AdminMenuSimpleStoragepoolsLazyRoute
  AdminMenuSimpleTestComponentsLazyRoute: typeof AdminMenuSimpleTestComponentsLazyRoute
  AdminMenuSimpleTrackingLazyRoute: typeof AdminMenuSimpleTrackingLazyRoute
  AdminMenuSimpleVmconfLazyRoute: typeof AdminMenuSimpleVmconfLazyRoute
  AdminMenuSimpleVmimagesLazyRoute: typeof AdminMenuSimpleVmimagesLazyRoute
  AdminMenuSimpleIndexLazyRoute: typeof AdminMenuSimpleIndexLazyRoute
  AdminMenuSimpleMetalOsLazyRoute: typeof AdminMenuSimpleMetalOsLazyRoute
  AdminMenuSimpleMetalSpecsLazyRoute: typeof AdminMenuSimpleMetalSpecsLazyRoute
  AdminMenuSimpleMetalMachinesIndexLazyRoute: typeof AdminMenuSimpleMetalMachinesIndexLazyRoute
  AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyRoute: typeof AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyRoute
}

const AdminMenuSimpleLazyRouteChildren: AdminMenuSimpleLazyRouteChildren = {
  AdminMenuSimpleAdminusersLazyRoute: AdminMenuSimpleAdminusersLazyRoute,
  AdminMenuSimpleCampaignsLazyRoute: AdminMenuSimpleCampaignsLazyRoute,
  AdminMenuSimpleConfigurationLazyRoute: AdminMenuSimpleConfigurationLazyRoute,
  AdminMenuSimpleCurrenciesLazyRoute: AdminMenuSimpleCurrenciesLazyRoute,
  AdminMenuSimpleCustomproductsLazyRoute:
    AdminMenuSimpleCustomproductsLazyRoute,
  AdminMenuSimpleGeneralLazyRoute: AdminMenuSimpleGeneralLazyRoute,
  AdminMenuSimpleHelpLazyRoute: AdminMenuSimpleHelpLazyRoute,
  AdminMenuSimpleHostpoolsLazyRoute: AdminMenuSimpleHostpoolsLazyRoute,
  AdminMenuSimpleLocationsLazyRoute: AdminMenuSimpleLocationsLazyRoute,
  AdminMenuSimplePricesLazyRoute: AdminMenuSimplePricesLazyRoute,
  AdminMenuSimpleReferralLazyRoute: AdminMenuSimpleReferralLazyRoute,
  AdminMenuSimpleStoragepoolsLazyRoute: AdminMenuSimpleStoragepoolsLazyRoute,
  AdminMenuSimpleTestComponentsLazyRoute:
    AdminMenuSimpleTestComponentsLazyRoute,
  AdminMenuSimpleTrackingLazyRoute: AdminMenuSimpleTrackingLazyRoute,
  AdminMenuSimpleVmconfLazyRoute: AdminMenuSimpleVmconfLazyRoute,
  AdminMenuSimpleVmimagesLazyRoute: AdminMenuSimpleVmimagesLazyRoute,
  AdminMenuSimpleIndexLazyRoute: AdminMenuSimpleIndexLazyRoute,
  AdminMenuSimpleMetalOsLazyRoute: AdminMenuSimpleMetalOsLazyRoute,
  AdminMenuSimpleMetalSpecsLazyRoute: AdminMenuSimpleMetalSpecsLazyRoute,
  AdminMenuSimpleMetalMachinesIndexLazyRoute:
    AdminMenuSimpleMetalMachinesIndexLazyRoute,
  AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyRoute:
    AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyRoute,
}

const AdminMenuSimpleLazyRouteWithChildren =
  AdminMenuSimpleLazyRoute._addFileChildren(AdminMenuSimpleLazyRouteChildren)

interface AdminMenuLazyRouteChildren {
  AdminMenuSimpleLazyRoute: typeof AdminMenuSimpleLazyRouteWithChildren
  AdminMenuDualVirtualmachinesRouteRoute: typeof AdminMenuDualVirtualmachinesRouteRoute
  AdminMenuDualAccountsLazyRoute: typeof AdminMenuDualAccountsLazyRoute
  AdminMenuDualBucketsLazyRoute: typeof AdminMenuDualBucketsLazyRoute
  AdminMenuDualFloatingipsLazyRoute: typeof AdminMenuDualFloatingipsLazyRoute
  AdminMenuDualHostsLazyRoute: typeof AdminMenuDualHostsLazyRoute
  AdminMenuDualLoadbalancersLazyRoute: typeof AdminMenuDualLoadbalancersLazyRoute
  AdminMenuDualReportsLazyRoute: typeof AdminMenuDualReportsLazyRoute
  AdminMenuDualServicepackagesLazyRoute: typeof AdminMenuDualServicepackagesLazyRoute
  AdminMenuDualUsersLazyRoute: typeof AdminMenuDualUsersLazyRoute
}

const AdminMenuLazyRouteChildren: AdminMenuLazyRouteChildren = {
  AdminMenuSimpleLazyRoute: AdminMenuSimpleLazyRouteWithChildren,
  AdminMenuDualVirtualmachinesRouteRoute:
    AdminMenuDualVirtualmachinesRouteRoute,
  AdminMenuDualAccountsLazyRoute: AdminMenuDualAccountsLazyRoute,
  AdminMenuDualBucketsLazyRoute: AdminMenuDualBucketsLazyRoute,
  AdminMenuDualFloatingipsLazyRoute: AdminMenuDualFloatingipsLazyRoute,
  AdminMenuDualHostsLazyRoute: AdminMenuDualHostsLazyRoute,
  AdminMenuDualLoadbalancersLazyRoute: AdminMenuDualLoadbalancersLazyRoute,
  AdminMenuDualReportsLazyRoute: AdminMenuDualReportsLazyRoute,
  AdminMenuDualServicepackagesLazyRoute: AdminMenuDualServicepackagesLazyRoute,
  AdminMenuDualUsersLazyRoute: AdminMenuDualUsersLazyRoute,
}

const AdminMenuLazyRouteWithChildren = AdminMenuLazyRoute._addFileChildren(
  AdminMenuLazyRouteChildren,
)

interface AdminLazyRouteChildren {
  AdminMenuLazyRoute: typeof AdminMenuLazyRouteWithChildren
}

const AdminLazyRouteChildren: AdminLazyRouteChildren = {
  AdminMenuLazyRoute: AdminMenuLazyRouteWithChildren,
}

const AdminLazyRouteWithChildren = AdminLazyRoute._addFileChildren(
  AdminLazyRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof MaincustomLazyRouteWithChildren
  '/auth0_callback': typeof Auth0callbackRoute
  '/consent_form': typeof ConsentformRoute
  '/email_verification': typeof EmailverificationRoute
  '/payment_return': typeof PaymentreturnRoute
  '/admin': typeof AdminMenuSimpleLazyRouteWithChildren
  '/test-error': typeof MainTestErrorLazyRoute
  '/about': typeof MaincustomAboutLazyRoute
  '/': typeof MainIndexLazyRoute
  '/services/create': typeof MainServicesCreateRoute
  '/billing/create': typeof MainBillingCreateLazyRoute
  '/compute/create': typeof MainComputeCreateLazyRoute
  '/disks/create': typeof MainDisksCreateLazyRoute
  '/metal/create': typeof MainMetalCreateLazyRoute
  '/section/$name': typeof MainSectionNameLazyRoute
  '/storage/create': typeof MainStorageCreateLazyRoute
  '/profile': typeof MainProfileIndexLazyRoute
  '/admin/virtual_machines': typeof AdminMenuDualVirtualmachinesRouteRoute
  '/access/create/$type': typeof MainAccessCreateTypeLazyRoute
  '/network/create/$type': typeof MainNetworkCreateTypeLazyRoute
  '/console/$location/$vmId': typeof MaincustomConsoleLocationVmIdLazyRoute
  '/admin/accounts': typeof AdminMenuDualAccountsLazyRoute
  '/admin/buckets': typeof AdminMenuDualBucketsLazyRoute
  '/admin/floating_ips': typeof AdminMenuDualFloatingipsLazyRoute
  '/admin/hosts': typeof AdminMenuDualHostsLazyRoute
  '/admin/load_balancers': typeof AdminMenuDualLoadbalancersLazyRoute
  '/admin/reports': typeof AdminMenuDualReportsLazyRoute
  '/admin/service_packages': typeof AdminMenuDualServicepackagesLazyRoute
  '/admin/users': typeof AdminMenuDualUsersLazyRoute
  '/admin/admin_users': typeof AdminMenuSimpleAdminusersLazyRoute
  '/admin/campaigns': typeof AdminMenuSimpleCampaignsLazyRoute
  '/admin/configuration': typeof AdminMenuSimpleConfigurationLazyRoute
  '/admin/currencies': typeof AdminMenuSimpleCurrenciesLazyRoute
  '/admin/custom_products': typeof AdminMenuSimpleCustomproductsLazyRoute
  '/admin/general': typeof AdminMenuSimpleGeneralLazyRoute
  '/admin/help': typeof AdminMenuSimpleHelpLazyRoute
  '/admin/host_pools': typeof AdminMenuSimpleHostpoolsLazyRoute
  '/admin/locations': typeof AdminMenuSimpleLocationsLazyRoute
  '/admin/prices': typeof AdminMenuSimplePricesLazyRoute
  '/admin/referral': typeof AdminMenuSimpleReferralLazyRoute
  '/admin/storage_pools': typeof AdminMenuSimpleStoragepoolsLazyRoute
  '/admin/test-components': typeof AdminMenuSimpleTestComponentsLazyRoute
  '/admin/tracking': typeof AdminMenuSimpleTrackingLazyRoute
  '/admin/vm_conf': typeof AdminMenuSimpleVmconfLazyRoute
  '/admin/vm_images': typeof AdminMenuSimpleVmimagesLazyRoute
  '/network/create': typeof MainNetworkCreateIndexRoute
  '/admin/': typeof AdminMenuSimpleIndexLazyRoute
  '/billing/account/$id/edit': typeof MainBillingAccountIdEditLazyRoute
  '/admin/console/$location/$vmId': typeof MaincustomAdminConsoleLocationVmIdLazyRoute
  '/admin/metal/os': typeof AdminMenuSimpleMetalOsLazyRoute
  '/admin/metal/specs': typeof AdminMenuSimpleMetalSpecsLazyRoute
  '/access/delegation/$id': typeof MainAccessDelegationIdIndexLazyRoute
  '/access/token/$id': typeof MainAccessTokenIdIndexLazyRoute
  '/billing/account/$id': typeof MainBillingAccountIdIndexLazyRoute
  '/storage/account/$accountUuid': typeof MainStorageAccountAccountUuidIndexLazyRoute
  '/storage/bucket/$storageName': typeof MainStorageBucketStorageNameIndexLazyRoute
  '/compute/vm/$location/$vmId': typeof MainComputeVmLocationVmIdIndexLazyRoute
  '/disks/disk/$location/$uuid': typeof MainDisksDiskLocationUuidIndexLazyRoute
  '/metal/lease/$location/$uuid': typeof MainMetalLeaseLocationUuidIndexLazyRoute
  '/network/firewall/$location/$uuid': typeof MainNetworkFirewallLocationUuidIndexLazyRoute
  '/network/ip_address/$location/$uuid': typeof MainNetworkIpaddressLocationUuidIndexLazyRoute
  '/network/load_balancer/$location/$uuid': typeof MainNetworkLoadbalancerLocationUuidIndexLazyRoute
  '/network/vpc/$location/$uuid': typeof MainNetworkVpcLocationUuidIndexLazyRoute
  '/services/service/$location/$serviceId': typeof MainServicesServiceLocationServiceIdIndexLazyRoute
  '/admin/metal/machines': typeof AdminMenuSimpleMetalMachinesIndexLazyRoute
  '/billing/account/$id/detail/$type/$invoiceId': typeof MainBillingAccountIdDetailTypeInvoiceIdLazyRoute
  '/admin/metal/machines/history/$location/$uuid': typeof AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyRoute
}

export interface FileRoutesByTo {
  '/auth0_callback': typeof Auth0callbackRoute
  '/consent_form': typeof ConsentformRoute
  '/email_verification': typeof EmailverificationRoute
  '/payment_return': typeof PaymentreturnRoute
  '': typeof MaincustomLazyRouteWithChildren
  '/admin': typeof AdminMenuSimpleIndexLazyRoute
  '/test-error': typeof MainTestErrorLazyRoute
  '/about': typeof MaincustomAboutLazyRoute
  '/': typeof MainIndexLazyRoute
  '/services/create': typeof MainServicesCreateRoute
  '/billing/create': typeof MainBillingCreateLazyRoute
  '/compute/create': typeof MainComputeCreateLazyRoute
  '/disks/create': typeof MainDisksCreateLazyRoute
  '/metal/create': typeof MainMetalCreateLazyRoute
  '/section/$name': typeof MainSectionNameLazyRoute
  '/storage/create': typeof MainStorageCreateLazyRoute
  '/profile': typeof MainProfileIndexLazyRoute
  '/admin/virtual_machines': typeof AdminMenuDualVirtualmachinesRouteRoute
  '/access/create/$type': typeof MainAccessCreateTypeLazyRoute
  '/network/create/$type': typeof MainNetworkCreateTypeLazyRoute
  '/console/$location/$vmId': typeof MaincustomConsoleLocationVmIdLazyRoute
  '/admin/accounts': typeof AdminMenuDualAccountsLazyRoute
  '/admin/buckets': typeof AdminMenuDualBucketsLazyRoute
  '/admin/floating_ips': typeof AdminMenuDualFloatingipsLazyRoute
  '/admin/hosts': typeof AdminMenuDualHostsLazyRoute
  '/admin/load_balancers': typeof AdminMenuDualLoadbalancersLazyRoute
  '/admin/reports': typeof AdminMenuDualReportsLazyRoute
  '/admin/service_packages': typeof AdminMenuDualServicepackagesLazyRoute
  '/admin/users': typeof AdminMenuDualUsersLazyRoute
  '/admin/admin_users': typeof AdminMenuSimpleAdminusersLazyRoute
  '/admin/campaigns': typeof AdminMenuSimpleCampaignsLazyRoute
  '/admin/configuration': typeof AdminMenuSimpleConfigurationLazyRoute
  '/admin/currencies': typeof AdminMenuSimpleCurrenciesLazyRoute
  '/admin/custom_products': typeof AdminMenuSimpleCustomproductsLazyRoute
  '/admin/general': typeof AdminMenuSimpleGeneralLazyRoute
  '/admin/help': typeof AdminMenuSimpleHelpLazyRoute
  '/admin/host_pools': typeof AdminMenuSimpleHostpoolsLazyRoute
  '/admin/locations': typeof AdminMenuSimpleLocationsLazyRoute
  '/admin/prices': typeof AdminMenuSimplePricesLazyRoute
  '/admin/referral': typeof AdminMenuSimpleReferralLazyRoute
  '/admin/storage_pools': typeof AdminMenuSimpleStoragepoolsLazyRoute
  '/admin/test-components': typeof AdminMenuSimpleTestComponentsLazyRoute
  '/admin/tracking': typeof AdminMenuSimpleTrackingLazyRoute
  '/admin/vm_conf': typeof AdminMenuSimpleVmconfLazyRoute
  '/admin/vm_images': typeof AdminMenuSimpleVmimagesLazyRoute
  '/network/create': typeof MainNetworkCreateIndexRoute
  '/billing/account/$id/edit': typeof MainBillingAccountIdEditLazyRoute
  '/admin/console/$location/$vmId': typeof MaincustomAdminConsoleLocationVmIdLazyRoute
  '/admin/metal/os': typeof AdminMenuSimpleMetalOsLazyRoute
  '/admin/metal/specs': typeof AdminMenuSimpleMetalSpecsLazyRoute
  '/access/delegation/$id': typeof MainAccessDelegationIdIndexLazyRoute
  '/access/token/$id': typeof MainAccessTokenIdIndexLazyRoute
  '/billing/account/$id': typeof MainBillingAccountIdIndexLazyRoute
  '/storage/account/$accountUuid': typeof MainStorageAccountAccountUuidIndexLazyRoute
  '/storage/bucket/$storageName': typeof MainStorageBucketStorageNameIndexLazyRoute
  '/compute/vm/$location/$vmId': typeof MainComputeVmLocationVmIdIndexLazyRoute
  '/disks/disk/$location/$uuid': typeof MainDisksDiskLocationUuidIndexLazyRoute
  '/metal/lease/$location/$uuid': typeof MainMetalLeaseLocationUuidIndexLazyRoute
  '/network/firewall/$location/$uuid': typeof MainNetworkFirewallLocationUuidIndexLazyRoute
  '/network/ip_address/$location/$uuid': typeof MainNetworkIpaddressLocationUuidIndexLazyRoute
  '/network/load_balancer/$location/$uuid': typeof MainNetworkLoadbalancerLocationUuidIndexLazyRoute
  '/network/vpc/$location/$uuid': typeof MainNetworkVpcLocationUuidIndexLazyRoute
  '/services/service/$location/$serviceId': typeof MainServicesServiceLocationServiceIdIndexLazyRoute
  '/admin/metal/machines': typeof AdminMenuSimpleMetalMachinesIndexLazyRoute
  '/billing/account/$id/detail/$type/$invoiceId': typeof MainBillingAccountIdDetailTypeInvoiceIdLazyRoute
  '/admin/metal/machines/history/$location/$uuid': typeof AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_main': typeof MainRouteWithChildren
  '/auth0_callback': typeof Auth0callbackRoute
  '/consent_form': typeof ConsentformRoute
  '/email_verification': typeof EmailverificationRoute
  '/payment_return': typeof PaymentreturnRoute
  '/_main_custom': typeof MaincustomLazyRouteWithChildren
  '/admin': typeof AdminLazyRouteWithChildren
  '/_main/test-error': typeof MainTestErrorLazyRoute
  '/_main_custom/about': typeof MaincustomAboutLazyRoute
  '/admin/_menu': typeof AdminMenuLazyRouteWithChildren
  '/_main/': typeof MainIndexLazyRoute
  '/_main/services/create': typeof MainServicesCreateRoute
  '/_main/billing/create': typeof MainBillingCreateLazyRoute
  '/_main/compute/create': typeof MainComputeCreateLazyRoute
  '/_main/disks/create': typeof MainDisksCreateLazyRoute
  '/_main/metal/create': typeof MainMetalCreateLazyRoute
  '/_main/section/$name': typeof MainSectionNameLazyRoute
  '/_main/storage/create': typeof MainStorageCreateLazyRoute
  '/admin/_menu/_simple': typeof AdminMenuSimpleLazyRouteWithChildren
  '/_main/profile/': typeof MainProfileIndexLazyRoute
  '/admin/_menu/_dual/virtual_machines': typeof AdminMenuDualVirtualmachinesRouteRoute
  '/_main/access/create/$type': typeof MainAccessCreateTypeLazyRoute
  '/_main/network/create/$type': typeof MainNetworkCreateTypeLazyRoute
  '/_main_custom/console/$location/$vmId': typeof MaincustomConsoleLocationVmIdLazyRoute
  '/admin/_menu/_dual/accounts': typeof AdminMenuDualAccountsLazyRoute
  '/admin/_menu/_dual/buckets': typeof AdminMenuDualBucketsLazyRoute
  '/admin/_menu/_dual/floating_ips': typeof AdminMenuDualFloatingipsLazyRoute
  '/admin/_menu/_dual/hosts': typeof AdminMenuDualHostsLazyRoute
  '/admin/_menu/_dual/load_balancers': typeof AdminMenuDualLoadbalancersLazyRoute
  '/admin/_menu/_dual/reports': typeof AdminMenuDualReportsLazyRoute
  '/admin/_menu/_dual/service_packages': typeof AdminMenuDualServicepackagesLazyRoute
  '/admin/_menu/_dual/users': typeof AdminMenuDualUsersLazyRoute
  '/admin/_menu/_simple/admin_users': typeof AdminMenuSimpleAdminusersLazyRoute
  '/admin/_menu/_simple/campaigns': typeof AdminMenuSimpleCampaignsLazyRoute
  '/admin/_menu/_simple/configuration': typeof AdminMenuSimpleConfigurationLazyRoute
  '/admin/_menu/_simple/currencies': typeof AdminMenuSimpleCurrenciesLazyRoute
  '/admin/_menu/_simple/custom_products': typeof AdminMenuSimpleCustomproductsLazyRoute
  '/admin/_menu/_simple/general': typeof AdminMenuSimpleGeneralLazyRoute
  '/admin/_menu/_simple/help': typeof AdminMenuSimpleHelpLazyRoute
  '/admin/_menu/_simple/host_pools': typeof AdminMenuSimpleHostpoolsLazyRoute
  '/admin/_menu/_simple/locations': typeof AdminMenuSimpleLocationsLazyRoute
  '/admin/_menu/_simple/prices': typeof AdminMenuSimplePricesLazyRoute
  '/admin/_menu/_simple/referral': typeof AdminMenuSimpleReferralLazyRoute
  '/admin/_menu/_simple/storage_pools': typeof AdminMenuSimpleStoragepoolsLazyRoute
  '/admin/_menu/_simple/test-components': typeof AdminMenuSimpleTestComponentsLazyRoute
  '/admin/_menu/_simple/tracking': typeof AdminMenuSimpleTrackingLazyRoute
  '/admin/_menu/_simple/vm_conf': typeof AdminMenuSimpleVmconfLazyRoute
  '/admin/_menu/_simple/vm_images': typeof AdminMenuSimpleVmimagesLazyRoute
  '/_main/network/create/': typeof MainNetworkCreateIndexRoute
  '/admin/_menu/_simple/': typeof AdminMenuSimpleIndexLazyRoute
  '/_main/billing/account/$id/edit': typeof MainBillingAccountIdEditLazyRoute
  '/_main_custom/admin/console/$location/$vmId': typeof MaincustomAdminConsoleLocationVmIdLazyRoute
  '/admin/_menu/_simple/metal/os': typeof AdminMenuSimpleMetalOsLazyRoute
  '/admin/_menu/_simple/metal/specs': typeof AdminMenuSimpleMetalSpecsLazyRoute
  '/_main/access/delegation/$id/': typeof MainAccessDelegationIdIndexLazyRoute
  '/_main/access/token/$id/': typeof MainAccessTokenIdIndexLazyRoute
  '/_main/billing/account/$id/': typeof MainBillingAccountIdIndexLazyRoute
  '/_main/storage/account/$accountUuid/': typeof MainStorageAccountAccountUuidIndexLazyRoute
  '/_main/storage/bucket/$storageName/': typeof MainStorageBucketStorageNameIndexLazyRoute
  '/_main/compute/vm/$location/$vmId/': typeof MainComputeVmLocationVmIdIndexLazyRoute
  '/_main/disks/disk/$location/$uuid/': typeof MainDisksDiskLocationUuidIndexLazyRoute
  '/_main/metal/lease/$location/$uuid/': typeof MainMetalLeaseLocationUuidIndexLazyRoute
  '/_main/network/firewall/$location/$uuid/': typeof MainNetworkFirewallLocationUuidIndexLazyRoute
  '/_main/network/ip_address/$location/$uuid/': typeof MainNetworkIpaddressLocationUuidIndexLazyRoute
  '/_main/network/load_balancer/$location/$uuid/': typeof MainNetworkLoadbalancerLocationUuidIndexLazyRoute
  '/_main/network/vpc/$location/$uuid/': typeof MainNetworkVpcLocationUuidIndexLazyRoute
  '/_main/services/service/$location/$serviceId/': typeof MainServicesServiceLocationServiceIdIndexLazyRoute
  '/admin/_menu/_simple/metal/machines/': typeof AdminMenuSimpleMetalMachinesIndexLazyRoute
  '/_main/billing/account/$id/detail/$type/$invoiceId': typeof MainBillingAccountIdDetailTypeInvoiceIdLazyRoute
  '/admin/_menu/_simple/metal/machines/history/$location/$uuid': typeof AdminMenuSimpleMetalMachinesHistoryLocationUuidLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/auth0_callback'
    | '/consent_form'
    | '/email_verification'
    | '/payment_return'
    | '/admin'
    | '/test-error'
    | '/about'
    | '/'
    | '/services/create'
    | '/billing/create'
    | '/compute/create'
    | '/disks/create'
    | '/metal/create'
    | '/section/$name'
    | '/storage/create'
    | '/profile'
    | '/admin/virtual_machines'
    | '/access/create/$type'
    | '/network/create/$type'
    | '/console/$location/$vmId'
    | '/admin/accounts'
    | '/admin/buckets'
    | '/admin/floating_ips'
    | '/admin/hosts'
    | '/admin/load_balancers'
    | '/admin/reports'
    | '/admin/service_packages'
    | '/admin/users'
    | '/admin/admin_users'
    | '/admin/campaigns'
    | '/admin/configuration'
    | '/admin/currencies'
    | '/admin/custom_products'
    | '/admin/general'
    | '/admin/help'
    | '/admin/host_pools'
    | '/admin/locations'
    | '/admin/prices'
    | '/admin/referral'
    | '/admin/storage_pools'
    | '/admin/test-components'
    | '/admin/tracking'
    | '/admin/vm_conf'
    | '/admin/vm_images'
    | '/network/create'
    | '/admin/'
    | '/billing/account/$id/edit'
    | '/admin/console/$location/$vmId'
    | '/admin/metal/os'
    | '/admin/metal/specs'
    | '/access/delegation/$id'
    | '/access/token/$id'
    | '/billing/account/$id'
    | '/storage/account/$accountUuid'
    | '/storage/bucket/$storageName'
    | '/compute/vm/$location/$vmId'
    | '/disks/disk/$location/$uuid'
    | '/metal/lease/$location/$uuid'
    | '/network/firewall/$location/$uuid'
    | '/network/ip_address/$location/$uuid'
    | '/network/load_balancer/$location/$uuid'
    | '/network/vpc/$location/$uuid'
    | '/services/service/$location/$serviceId'
    | '/admin/metal/machines'
    | '/billing/account/$id/detail/$type/$invoiceId'
    | '/admin/metal/machines/history/$location/$uuid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth0_callback'
    | '/consent_form'
    | '/email_verification'
    | '/payment_return'
    | ''
    | '/admin'
    | '/test-error'
    | '/about'
    | '/'
    | '/services/create'
    | '/billing/create'
    | '/compute/create'
    | '/disks/create'
    | '/metal/create'
    | '/section/$name'
    | '/storage/create'
    | '/profile'
    | '/admin/virtual_machines'
    | '/access/create/$type'
    | '/network/create/$type'
    | '/console/$location/$vmId'
    | '/admin/accounts'
    | '/admin/buckets'
    | '/admin/floating_ips'
    | '/admin/hosts'
    | '/admin/load_balancers'
    | '/admin/reports'
    | '/admin/service_packages'
    | '/admin/users'
    | '/admin/admin_users'
    | '/admin/campaigns'
    | '/admin/configuration'
    | '/admin/currencies'
    | '/admin/custom_products'
    | '/admin/general'
    | '/admin/help'
    | '/admin/host_pools'
    | '/admin/locations'
    | '/admin/prices'
    | '/admin/referral'
    | '/admin/storage_pools'
    | '/admin/test-components'
    | '/admin/tracking'
    | '/admin/vm_conf'
    | '/admin/vm_images'
    | '/network/create'
    | '/billing/account/$id/edit'
    | '/admin/console/$location/$vmId'
    | '/admin/metal/os'
    | '/admin/metal/specs'
    | '/access/delegation/$id'
    | '/access/token/$id'
    | '/billing/account/$id'
    | '/storage/account/$accountUuid'
    | '/storage/bucket/$storageName'
    | '/compute/vm/$location/$vmId'
    | '/disks/disk/$location/$uuid'
    | '/metal/lease/$location/$uuid'
    | '/network/firewall/$location/$uuid'
    | '/network/ip_address/$location/$uuid'
    | '/network/load_balancer/$location/$uuid'
    | '/network/vpc/$location/$uuid'
    | '/services/service/$location/$serviceId'
    | '/admin/metal/machines'
    | '/billing/account/$id/detail/$type/$invoiceId'
    | '/admin/metal/machines/history/$location/$uuid'
  id:
    | '__root__'
    | '/_main'
    | '/auth0_callback'
    | '/consent_form'
    | '/email_verification'
    | '/payment_return'
    | '/_main_custom'
    | '/admin'
    | '/_main/test-error'
    | '/_main_custom/about'
    | '/admin/_menu'
    | '/_main/'
    | '/_main/services/create'
    | '/_main/billing/create'
    | '/_main/compute/create'
    | '/_main/disks/create'
    | '/_main/metal/create'
    | '/_main/section/$name'
    | '/_main/storage/create'
    | '/admin/_menu/_simple'
    | '/_main/profile/'
    | '/admin/_menu/_dual/virtual_machines'
    | '/_main/access/create/$type'
    | '/_main/network/create/$type'
    | '/_main_custom/console/$location/$vmId'
    | '/admin/_menu/_dual/accounts'
    | '/admin/_menu/_dual/buckets'
    | '/admin/_menu/_dual/floating_ips'
    | '/admin/_menu/_dual/hosts'
    | '/admin/_menu/_dual/load_balancers'
    | '/admin/_menu/_dual/reports'
    | '/admin/_menu/_dual/service_packages'
    | '/admin/_menu/_dual/users'
    | '/admin/_menu/_simple/admin_users'
    | '/admin/_menu/_simple/campaigns'
    | '/admin/_menu/_simple/configuration'
    | '/admin/_menu/_simple/currencies'
    | '/admin/_menu/_simple/custom_products'
    | '/admin/_menu/_simple/general'
    | '/admin/_menu/_simple/help'
    | '/admin/_menu/_simple/host_pools'
    | '/admin/_menu/_simple/locations'
    | '/admin/_menu/_simple/prices'
    | '/admin/_menu/_simple/referral'
    | '/admin/_menu/_simple/storage_pools'
    | '/admin/_menu/_simple/test-components'
    | '/admin/_menu/_simple/tracking'
    | '/admin/_menu/_simple/vm_conf'
    | '/admin/_menu/_simple/vm_images'
    | '/_main/network/create/'
    | '/admin/_menu/_simple/'
    | '/_main/billing/account/$id/edit'
    | '/_main_custom/admin/console/$location/$vmId'
    | '/admin/_menu/_simple/metal/os'
    | '/admin/_menu/_simple/metal/specs'
    | '/_main/access/delegation/$id/'
    | '/_main/access/token/$id/'
    | '/_main/billing/account/$id/'
    | '/_main/storage/account/$accountUuid/'
    | '/_main/storage/bucket/$storageName/'
    | '/_main/compute/vm/$location/$vmId/'
    | '/_main/disks/disk/$location/$uuid/'
    | '/_main/metal/lease/$location/$uuid/'
    | '/_main/network/firewall/$location/$uuid/'
    | '/_main/network/ip_address/$location/$uuid/'
    | '/_main/network/load_balancer/$location/$uuid/'
    | '/_main/network/vpc/$location/$uuid/'
    | '/_main/services/service/$location/$serviceId/'
    | '/admin/_menu/_simple/metal/machines/'
    | '/_main/billing/account/$id/detail/$type/$invoiceId'
    | '/admin/_menu/_simple/metal/machines/history/$location/$uuid'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  MainRoute: typeof MainRouteWithChildren
  Auth0callbackRoute: typeof Auth0callbackRoute
  ConsentformRoute: typeof ConsentformRoute
  EmailverificationRoute: typeof EmailverificationRoute
  PaymentreturnRoute: typeof PaymentreturnRoute
  MaincustomLazyRoute: typeof MaincustomLazyRouteWithChildren
  AdminLazyRoute: typeof AdminLazyRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  MainRoute: MainRouteWithChildren,
  Auth0callbackRoute: Auth0callbackRoute,
  ConsentformRoute: ConsentformRoute,
  EmailverificationRoute: EmailverificationRoute,
  PaymentreturnRoute: PaymentreturnRoute,
  MaincustomLazyRoute: MaincustomLazyRouteWithChildren,
  AdminLazyRoute: AdminLazyRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_main",
        "/auth0_callback",
        "/consent_form",
        "/email_verification",
        "/payment_return",
        "/_main_custom",
        "/admin"
      ]
    },
    "/_main": {
      "filePath": "_main.tsx",
      "children": [
        "/_main/test-error",
        "/_main/",
        "/_main/services/create",
        "/_main/billing/create",
        "/_main/compute/create",
        "/_main/disks/create",
        "/_main/metal/create",
        "/_main/section/$name",
        "/_main/storage/create",
        "/_main/profile/",
        "/_main/access/create/$type",
        "/_main/network/create/$type",
        "/_main/network/create/",
        "/_main/billing/account/$id/edit",
        "/_main/access/delegation/$id/",
        "/_main/access/token/$id/",
        "/_main/billing/account/$id/",
        "/_main/storage/account/$accountUuid/",
        "/_main/storage/bucket/$storageName/",
        "/_main/compute/vm/$location/$vmId/",
        "/_main/disks/disk/$location/$uuid/",
        "/_main/metal/lease/$location/$uuid/",
        "/_main/network/firewall/$location/$uuid/",
        "/_main/network/ip_address/$location/$uuid/",
        "/_main/network/load_balancer/$location/$uuid/",
        "/_main/network/vpc/$location/$uuid/",
        "/_main/services/service/$location/$serviceId/",
        "/_main/billing/account/$id/detail/$type/$invoiceId"
      ]
    },
    "/auth0_callback": {
      "filePath": "auth0_callback.tsx"
    },
    "/consent_form": {
      "filePath": "consent_form.ts"
    },
    "/email_verification": {
      "filePath": "email_verification.ts"
    },
    "/payment_return": {
      "filePath": "payment_return.ts"
    },
    "/_main_custom": {
      "filePath": "_main_custom.lazy.tsx",
      "children": [
        "/_main_custom/about",
        "/_main_custom/console/$location/$vmId",
        "/_main_custom/admin/console/$location/$vmId"
      ]
    },
    "/admin": {
      "filePath": "admin.lazy.tsx",
      "children": [
        "/admin/_menu"
      ]
    },
    "/_main/test-error": {
      "filePath": "_main/test-error.lazy.tsx",
      "parent": "/_main"
    },
    "/_main_custom/about": {
      "filePath": "_main_custom/about.lazy.tsx",
      "parent": "/_main_custom"
    },
    "/admin/_menu": {
      "filePath": "admin/_menu.lazy.tsx",
      "parent": "/admin",
      "children": [
        "/admin/_menu/_simple",
        "/admin/_menu/_dual/virtual_machines",
        "/admin/_menu/_dual/accounts",
        "/admin/_menu/_dual/buckets",
        "/admin/_menu/_dual/floating_ips",
        "/admin/_menu/_dual/hosts",
        "/admin/_menu/_dual/load_balancers",
        "/admin/_menu/_dual/reports",
        "/admin/_menu/_dual/service_packages",
        "/admin/_menu/_dual/users"
      ]
    },
    "/_main/": {
      "filePath": "_main/index.lazy.ts",
      "parent": "/_main"
    },
    "/_main/services/create": {
      "filePath": "_main/services/create.tsx",
      "parent": "/_main"
    },
    "/_main/billing/create": {
      "filePath": "_main/billing/create.lazy.ts",
      "parent": "/_main"
    },
    "/_main/compute/create": {
      "filePath": "_main/compute/create.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/disks/create": {
      "filePath": "_main/disks/create.lazy.ts",
      "parent": "/_main"
    },
    "/_main/metal/create": {
      "filePath": "_main/metal/create.lazy.ts",
      "parent": "/_main"
    },
    "/_main/section/$name": {
      "filePath": "_main/section/$name.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/storage/create": {
      "filePath": "_main/storage/create.lazy.tsx",
      "parent": "/_main"
    },
    "/admin/_menu/_simple": {
      "filePath": "admin/_menu/_simple.lazy.tsx",
      "parent": "/admin/_menu",
      "children": [
        "/admin/_menu/_simple/admin_users",
        "/admin/_menu/_simple/campaigns",
        "/admin/_menu/_simple/configuration",
        "/admin/_menu/_simple/currencies",
        "/admin/_menu/_simple/custom_products",
        "/admin/_menu/_simple/general",
        "/admin/_menu/_simple/help",
        "/admin/_menu/_simple/host_pools",
        "/admin/_menu/_simple/locations",
        "/admin/_menu/_simple/prices",
        "/admin/_menu/_simple/referral",
        "/admin/_menu/_simple/storage_pools",
        "/admin/_menu/_simple/test-components",
        "/admin/_menu/_simple/tracking",
        "/admin/_menu/_simple/vm_conf",
        "/admin/_menu/_simple/vm_images",
        "/admin/_menu/_simple/",
        "/admin/_menu/_simple/metal/os",
        "/admin/_menu/_simple/metal/specs",
        "/admin/_menu/_simple/metal/machines/",
        "/admin/_menu/_simple/metal/machines/history/$location/$uuid"
      ]
    },
    "/_main/profile/": {
      "filePath": "_main/profile/index.lazy.ts",
      "parent": "/_main"
    },
    "/admin/_menu/_dual/virtual_machines": {
      "filePath": "admin/_menu/_dual/virtual_machines.route.tsx",
      "parent": "/admin/_menu"
    },
    "/_main/access/create/$type": {
      "filePath": "_main/access/create.$type.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/network/create/$type": {
      "filePath": "_main/network/create.$type.lazy.tsx",
      "parent": "/_main"
    },
    "/_main_custom/console/$location/$vmId": {
      "filePath": "_main_custom/console.$location.$vmId.lazy.tsx",
      "parent": "/_main_custom"
    },
    "/admin/_menu/_dual/accounts": {
      "filePath": "admin/_menu/_dual/accounts.lazy.tsx",
      "parent": "/admin/_menu"
    },
    "/admin/_menu/_dual/buckets": {
      "filePath": "admin/_menu/_dual/buckets.lazy.tsx",
      "parent": "/admin/_menu"
    },
    "/admin/_menu/_dual/floating_ips": {
      "filePath": "admin/_menu/_dual/floating_ips.lazy.tsx",
      "parent": "/admin/_menu"
    },
    "/admin/_menu/_dual/hosts": {
      "filePath": "admin/_menu/_dual/hosts.lazy.tsx",
      "parent": "/admin/_menu"
    },
    "/admin/_menu/_dual/load_balancers": {
      "filePath": "admin/_menu/_dual/load_balancers.lazy.tsx",
      "parent": "/admin/_menu"
    },
    "/admin/_menu/_dual/reports": {
      "filePath": "admin/_menu/_dual/reports.lazy.tsx",
      "parent": "/admin/_menu"
    },
    "/admin/_menu/_dual/service_packages": {
      "filePath": "admin/_menu/_dual/service_packages.lazy.tsx",
      "parent": "/admin/_menu"
    },
    "/admin/_menu/_dual/users": {
      "filePath": "admin/_menu/_dual/users.lazy.tsx",
      "parent": "/admin/_menu"
    },
    "/admin/_menu/_simple/admin_users": {
      "filePath": "admin/_menu/_simple/admin_users.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/campaigns": {
      "filePath": "admin/_menu/_simple/campaigns.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/configuration": {
      "filePath": "admin/_menu/_simple/configuration.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/currencies": {
      "filePath": "admin/_menu/_simple/currencies.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/custom_products": {
      "filePath": "admin/_menu/_simple/custom_products.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/general": {
      "filePath": "admin/_menu/_simple/general.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/help": {
      "filePath": "admin/_menu/_simple/help.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/host_pools": {
      "filePath": "admin/_menu/_simple/host_pools.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/locations": {
      "filePath": "admin/_menu/_simple/locations.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/prices": {
      "filePath": "admin/_menu/_simple/prices.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/referral": {
      "filePath": "admin/_menu/_simple/referral.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/storage_pools": {
      "filePath": "admin/_menu/_simple/storage_pools.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/test-components": {
      "filePath": "admin/_menu/_simple/test-components.lazy.tsx",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/tracking": {
      "filePath": "admin/_menu/_simple/tracking.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/vm_conf": {
      "filePath": "admin/_menu/_simple/vm_conf.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/vm_images": {
      "filePath": "admin/_menu/_simple/vm_images.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/_main/network/create/": {
      "filePath": "_main/network/create.index.tsx",
      "parent": "/_main"
    },
    "/admin/_menu/_simple/": {
      "filePath": "admin/_menu/_simple/index.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/_main/billing/account/$id/edit": {
      "filePath": "_main/billing/account.$id/edit.lazy.tsx",
      "parent": "/_main"
    },
    "/_main_custom/admin/console/$location/$vmId": {
      "filePath": "_main_custom/admin/console.$location.$vmId.lazy.tsx",
      "parent": "/_main_custom"
    },
    "/admin/_menu/_simple/metal/os": {
      "filePath": "admin/_menu/_simple/metal/os.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/admin/_menu/_simple/metal/specs": {
      "filePath": "admin/_menu/_simple/metal/specs.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/_main/access/delegation/$id/": {
      "filePath": "_main/access/delegation/$id/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/access/token/$id/": {
      "filePath": "_main/access/token/$id/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/billing/account/$id/": {
      "filePath": "_main/billing/account.$id/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/storage/account/$accountUuid/": {
      "filePath": "_main/storage/account.$accountUuid/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/storage/bucket/$storageName/": {
      "filePath": "_main/storage/bucket.$storageName/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/compute/vm/$location/$vmId/": {
      "filePath": "_main/compute/vm.$location.$vmId/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/disks/disk/$location/$uuid/": {
      "filePath": "_main/disks/disk/$location/$uuid/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/metal/lease/$location/$uuid/": {
      "filePath": "_main/metal/lease.$location.$uuid/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/network/firewall/$location/$uuid/": {
      "filePath": "_main/network/firewall/$location/$uuid/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/network/ip_address/$location/$uuid/": {
      "filePath": "_main/network/ip_address/$location/$uuid/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/network/load_balancer/$location/$uuid/": {
      "filePath": "_main/network/load_balancer/$location/$uuid/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/network/vpc/$location/$uuid/": {
      "filePath": "_main/network/vpc/$location/$uuid/index.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/services/service/$location/$serviceId/": {
      "filePath": "_main/services/service.$location.$serviceId/index.lazy.tsx",
      "parent": "/_main"
    },
    "/admin/_menu/_simple/metal/machines/": {
      "filePath": "admin/_menu/_simple/metal/machines/index.lazy.ts",
      "parent": "/admin/_menu/_simple"
    },
    "/_main/billing/account/$id/detail/$type/$invoiceId": {
      "filePath": "_main/billing/account.$id/detail.$type.$invoiceId.lazy.tsx",
      "parent": "/_main"
    },
    "/admin/_menu/_simple/metal/machines/history/$location/$uuid": {
      "filePath": "admin/_menu/_simple/metal/machines/history.$location.$uuid.lazy.tsx",
      "parent": "/admin/_menu/_simple"
    }
  }
}
ROUTE_MANIFEST_END */
